
$(document).ready(function(e){
	if ($(document).find('.range-field')){
		$(document).find('.range-field').each(function(){

			var dom = $(this);
			var input = dom.find('.range-field__input');
			var min = parseInt(input.attr('min'));
			var max = parseInt(input.attr('max'));
			var step = parseInt(input.attr('step'));
			var number_of_steps = (max - min) / step;

			input.on('input', function(e){
				render(e.target.value);
			});

			// Inject a marker for each step
			for (var i = 0; i <= number_of_steps; i++){
				var step_dot = $('<div class="range-field__track__step"></div>');
				step_dot.css({left: (i / number_of_steps) * 100 +"%"});
				dom.find('.range-field__track').append(step_dot);
			}

			// Render the slider
			function render(value){

				// Default to whatever is in the input field
				if (typeof(value) === undefined || !value){
					var value = input.val();
				}

				var percent = parseInt(value) / (max - min) * 100;
				dom.find('.range-field__track__progress').css({width: percent+'%'});
			}

			// Render on load
			render();
		});
	}
});